<template>
    <div>
        <modal id="addSpace" ref="modalForm" :starts-open="true" class="modal-wide">
            <form slot="body">
                <div>
                    <div class="form-group">
                        <label for="name">{{ t('name') }}</label>
                        <input type="text" class="form-control" id="name" v-model="form.name">
                    </div>
                    <div class="form-group">
                        <label>{{ t('fields') }}</label>
                        <table class="table">
                            <thead>
                            <tr>
                                <th>{{ t('name') }}</th>
                                <th>{{ t('type') }}</th>
                                <th>{{ t('smart_insertion-required') }}</th>
                                <th>{{ t('options') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(field, index) in form.fields" :key="index">
                                <td>
                                    <input type="text" class="form-control" v-model="field.name">
                                </td>
                                <td>
                                    <select class="form-control" v-model="field.type">
                                        <option value="text">{{ t('smart_insertion-short_text') }}</option>
                                        <option value="textarea">{{ t('smart_insertion-long_text') }}</option>
                                        <option value="html">{{ t('smart_insertion-html') }}</option>
                                    </select>
                                </td>
                                <td>
                                    <input type="checkbox" v-model="field.required">
                                </td>
                                <td>
                                    <button class="btn btn-danger btn-sm" @click="form.fields.splice(index, 1)">
                                        {{ t('remove') }}
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-primary btn-sm"
                                @click="form.fields.push({name: '', type: 'text', required: false})">
                            {{ t('smart_insertion-add_field') }}
                        </button>
                    </div>
                </div>
            </form>
            <div slot="footer">
                <button class="btn btn-outline-secondary" @click="close">{{ t('cancel') }}</button>

                <button class="btn btn-primary" @click="save">{{ t('save') }}</button>
            </div>
        </modal>
        <div class="box">
            <div class="title">
                <h3>{{ t('smart_insertion-title') }}</h3>
                <div class="btn btn-primary btn-sm" @click="openModal">
                    {{ t('smart_insertion-register_space') }}
                </div>
            </div>
            <table class="table">
                <thead>
                <tr>
                    <th>{{ t('smart_insertion-name_id') }}</th>
                    <th>{{ t('options') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(space, index) in spaces" :key="index">
                    <td>{{ space.name }} <small>({{ space.slug }})</small></td>
                    <td>
                        <button class="btn btn-danger btn-sm">
                            {{ t('remove') }}
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";

export default {
    components: {},
    data() {
        return {
            name: "",
            form: {
                id: null,
                name: "",
                fields: [],
            },
            saving: false,
            spaces: [],
        };
    },
    mounted() {
        this.loadSpaces();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        openModal() {
            this.$refs.modalForm.open();
        },
        close() {
            this.$refs.modalForm.close();
        },
        async loadSpaces() {
            const options = keviApi.getOptions("smart-insertions/spaces", "GET");
            this.$http(options).then((response) => {
                this.spaces = response.data;
            });
        },
        async save() {
            this.saving = true;
            const options = keviApi.getOptions("smart-insertions/spaces", "POST", this.form);
            this.$http(options).then((response) => {
                this.saving = false;
                this.close();
            });
        },
    },
}
</script>
